(() => {
  const brandAliases = new Map([
    ['فيليبس', 'philips'],
    ['فيلبس', 'philips'],
    ['فيليبـس', 'philips'],
  ]);

  const normalizeBrandName = (value) => {
    const normalized = String(value || '')
      .normalize('NFKD')
      .toLocaleLowerCase()
      .replace(/[\u064B-\u065F\u0670\u0640]/g, '')
      .replace(/[^\p{L}\p{N}]+/gu, ' ')
      .trim();

    return brandAliases.get(normalized) || normalized;
  };

  const arabicToLatin = {
    ا: 'a', أ: 'a', إ: 'a', آ: 'a', ب: 'b', ت: 't', ث: 'th', ج: 'g', ح: 'h', خ: 'kh',
    د: 'd', ذ: 'th', ر: 'r', ز: 'z', س: 's', ش: 'sh', ص: 's', ض: 'd', ط: 't', ظ: 'z',
    ع: '', غ: 'g', ف: 'f', ق: 'k', ك: 'k', ل: 'l', م: 'm', ن: 'n', ه: 'h', ة: 'a',
    و: 'u', ي: 'i', ى: 'a', ئ: 'i', ؤ: 'u', ء: '',
  };

  const phoneticBrandKey = (value) => {
    const normalized = normalizeBrandName(value);
    const latin = [...normalized].map((character) => arabicToLatin[character] ?? character).join('');

    return latin
      .replace(/ph/g, 'f')
      .replace(/x/g, 'ks')
      .replace(/[cq]/g, 'k')
      .replace(/j/g, 'g')
      .replace(/p/g, 'b')
      .replace(/v/g, 'f')
      .replace(/[aeiouy\s]+/g, '')
      .replace(/(.)\1+/g, '$1');
  };

  const initializeBrandSearch = () => {
    document.querySelectorAll('[data-rwady-brand-search-form]').forEach((form) => {
      if (form.dataset.initialized === 'true') return;
      form.dataset.initialized = 'true';

      const input = form.querySelector('[data-rwady-brand-search-input]');
      const clearButton = form.querySelector('[data-rwady-brand-search-clear]');
      const page = form.closest('.rwady-brands-page');
      const items = [...page.querySelectorAll('[data-rwady-brand-item]')];
      const empty = page.querySelector('[data-rwady-brand-empty]');

      const filterBrands = () => {
        const query = normalizeBrandName(input.value);
        const queryPhonetic = phoneticBrandKey(query);
        let visibleCount = 0;

        clearButton.hidden = input.value.length === 0;

        items.forEach((item) => {
          const brandName = normalizeBrandName(item.dataset.brandName);
          const brandPhonetic = phoneticBrandKey(brandName);
          const isPhoneticMatch = queryPhonetic.length >= 2 && brandPhonetic.includes(queryPhonetic);
          const isVisible = !query || brandName.includes(query) || isPhoneticMatch;
          item.hidden = !isVisible;
          if (isVisible) visibleCount += 1;
        });

        empty.hidden = visibleCount !== 0;
      };

      input.addEventListener('input', filterBrands);
      clearButton.addEventListener('click', () => {
        input.value = '';
        filterBrands();
        input.focus();
      });
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        filterBrands();
      });
    });
  };

  document.addEventListener('DOMContentLoaded', initializeBrandSearch);
  document.addEventListener('shopify:section:load', initializeBrandSearch);
})();
